module.exports = __webpack_public_path__ + "static/media/ClutchBlack.ff3170cc.svg";